export const headerText = {
  en: {
    menuItem1: "HOME",
    menuItem2: "FAQ",
    menuItem3: "SIGN IN",
    menuItem4: "DASHBOARD",
  },
  tr: {
    menuItem1: "ANASAYFA",
    menuItem2: "SSS",
    menuItem3: "GİRİŞ",
    menuItem4: "PANEL",
  },
};
